import { Reputation } from '~/models/reputation';

export const reputationService = {
	fetch: async (): Promise<Reputation.Model | null> => {
		const params = {
			fields: ['*', 'photo.*', 'form.*'],
		};

		try {
			const response = await $fetch<Reputation.Model>(Reputation.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Reputation:', error);

			return null;
		}
	},
};
